/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import { ModalType } from '../../../app/types';
import Button from '../../shared/Button';
import TextField from '../../shared/TextField';

import Modal from '../../shared/Modal';
import { color } from '../../../app/theme';
import IconDelete from '../../../assets/images/Icons/IconDelete';
import Tooltip from '../../shared/Tooltip';
import { closeModal, openModal } from '../../../features/modalSlice';
import {
  createLineLiff,
  deleteLineLiff,
} from '../../../features/ecBindingSlice';
import config from '../../../app/config';

const useStyles = makeStyles(
  () => ({
    titleStyle: {
      marginBottom: '12px',
      '& > a': {
        color: color.$2,
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:hover': {
          color: color.$1,
        },
      },
    },
    red: {
      color: color.$17,
      marginLeft: 4,
    },
    input: {
      '& .Mui-disabled': {
        WebkitTextFillColor: color.$10,
        backgroundColor: color.$8,
      },
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      width: 24,
      marginLeft: 4,
      cursor: 'pointer',
    },
    liffRow: {
      display: 'flex',
    },
  }),
  {
    name: 'LineChannelModal',
  },
);

const LineChannelModal = ({
  isOpen,
  setModalStatus,
  liffName,
  onClose,
  lineChannelInfo,
  getLineChannelInfo,
}) => {
  const dispatch = useDispatch();

  const classes = useStyles();
  const { t } = useTranslation();
  const [isCreateLoading, setIsCreateLoading] = useState(false);

  const { orgId } = useParams();

  const { data } = useSelector(store => store.ecBinding);
  const { liffSetting } = data || {};
  const isLineLoginSetting = !!liffSetting;

  const onChannelClose = () => {
    onClose();
  };

  const onLiffCreate = async () => {
    try {
      setIsCreateLoading(true);
      await dispatch(createLineLiff(orgId, liffName));
      await getLineChannelInfo();
    } finally {
      setIsCreateLoading(false);
    }
  };

  const goLineLoginSetting = () => {
    if (isLineLoginSetting) {
      window.location.href = `${config.CONSOLE_URL}/organization-setting/${orgId}/linked-app/ConnenctedLineLoginSetting`;
    } else {
      window.location.href = `${config.CONSOLE_URL}/organization-setting/${orgId}/linked-app/lineLoginSetting`;
    }
  };

  function handleClickDelete() {
    dispatch(
      openModal({
        modalType: ModalType.ALERT_MODAL,
        modalProps: {
          title: t('deleteLiff'),
          content: t('deleteLiffContent'),
          submitText: t('modal.submit'),
          canceltext: t('modal.not-now'),
          onClick: async () => {
            dispatch(closeModal());
            await dispatch(deleteLineLiff(orgId, liffName));
            await getLineChannelInfo();
          },
        },
      }),
    );
  }

  const renderChannelContent = () => {
    return (
      <>
        <Typography variant="subtitle1" className={classes.titleStyle}>
          {t(`set-connect-description`)}
          <a onClick={() => goLineLoginSetting()} rel="noopener noreferrer">
            {t(`checkhelp`)}
          </a>
        </Typography>

        <Typography
          variant="subtitle1"
          style={{ paddingTop: 12 }}
          className={classes.titleStyle}
        >
          {t(`set-connect-channelId`)}
        </Typography>
        <TextField
          value={lineChannelInfo?.channelId}
          className={classes.input}
          disabled
          style={{ marginBottom: '24px' }}
          placeholder={t(`set-connect-channelId-placeholder`)}
        />
        <Typography variant="subtitle1" className={classes.titleStyle}>
          {t(`set-connect-channelSecret`)}
        </Typography>
        <TextField
          value={lineChannelInfo?.channelSecret}
          className={classes.input}
          disabled
          style={{ marginBottom: '24px' }}
          placeholder={t(`set-connect-channelSecret-placeholder`)}
        />
        <Typography variant="subtitle1" className={classes.titleStyle}>
          {t(`set-connect-liffId`)}
          <span className={classes.red}>*</span>
        </Typography>

        {lineChannelInfo?.liffId ? (
          <div className={classes.liffRow}>
            <TextField
              value={lineChannelInfo.liffId}
              className={classes.input}
              disabled
            />

            {!lineChannelInfo?.isLegacy && (
              <Tooltip placement="top" title={t('deleteLiff')}>
                <span
                  className={classes.icon}
                  onClick={handleClickDelete}
                  id="span-icon-delete-line-login-setting"
                >
                  <IconDelete
                    id="icon-delete-line-login-setting"
                    hoverColor={color.$1}
                    width={24}
                    height={24}
                  />
                </span>
              </Tooltip>
            )}
          </div>
        ) : (
          <Button
            className="actionButton"
            onClick={() => {
              onLiffCreate();
            }}
            isLoading={isCreateLoading}
            topic="primaryGreen"
            isDisable={!isLineLoginSetting}
          >
            {t('autoGenerate')}
          </Button>
        )}
      </>
    );
  };

  const renderChannelAction = () => (
    <>
      <Button
        className="actionButton"
        onClick={() => {
          onChannelClose();
        }}
        type="submit"
        topic="primaryBlue"
      >
        {t('modal.close')}
      </Button>
    </>
  );

  return (
    <>
      {isOpen && (
        <Modal
          style={{ width: '960px' }}
          title={t(`set-connect-title`)}
          content={renderChannelContent()}
          actions={renderChannelAction()}
          open={isOpen}
          handleClose={() => {
            setModalStatus(false);
          }}
        />
      )}
    </>
  );
};

LineChannelModal.defaultProps = {
  isOpen: 'false',
};

export default LineChannelModal;
